var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RCheckIdentify2 bg-white"},[_c('div',{staticClass:"login-title"},[_vm._v("\n    身份验证\n  ")]),_c('t-identify-attachment-file',{ref:"check"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }